<template>
  <v-dialog persistent width="650px" :value="show">
    <v-card :loading="isLoading">
      <div class="px-6 py-4">
        <v-card-title class="ma-0 pa-0 mb-4">
          <p class="ma-0 pa-0 h6 font-weight-600">
            {{ textTitle }}
          </p>
        </v-card-title>

        <v-card-text class="mt-4 pa-0 d-flex align-start">
          <UserAvatar :account="account" size="32px" fontSize="10px" />
          <RecognitionComposer
            class="flex-grow-1 mt-n2"
            showCancel
            :initialAccountIds="initialAccounts"
            :initialMessage="initialMessage"
            :submitButtonText="buttonText"
            @submit="handleSubmit"
            @cancel="showDialog = true"
          />
        </v-card-text>
      </div>
    </v-card>
    <DiscardChangesDialog
      :show="showDialog"
      :title="$t('recognitions.discard_recognition_title')"
      :text="$t('recognitions.discard_recognition_text')"
      :confirmText="$t('common.button.discard')"
      @cancel="showDialog = false"
      @delete="handleDiscardChanges"
    />
  </v-dialog>
</template>
<script>
import UserAvatar from '@/components/UserAvatar.vue'
import RecognitionComposer from '@/components/RecognitionComposer.vue'
import DiscardChangesDialog from '@/components/Modals/DeleteConfirmationModal.vue'

import mixin from '@/mixins/mixin.vue'
import api from '@/api'

import { mapGetters } from 'vuex'

export default {
  name: 'RecognitionDialog',

  mixins: [mixin],

  props: { show: Boolean, recognition: Object, initialAccounts: Array },

  components: {
    DiscardChangesDialog,
    UserAvatar,
    RecognitionComposer,
  },

  data() {
    return {
      showDialog: false,
      isLoading: false,
    }
  },

  computed: {
    ...mapGetters(['account', 'organizationId', 'accountId', 'organization']),
    initialMessage() {
      return this.recognition?.content
    },
    isEditing() {
      return Boolean(this.recognition?.id)
    },
    textTitle() {
      return this.isEditing
        ? this.$t('recognitions.edit_recognition')
        : this.$t('recognitions.give_a_recognition')
    },
    buttonText() {
      return this.isEditing
        ? this.$t('common.button.save')
        : this.$t('recognitions.recognize')
    },
  },

  methods: {
    handleSubmit({ message, accountIds }) {
      if (!accountIds.length)
        return this.showError(this.$t('recognitions.select_someone'))
      if (this.isEditing) return this.updateRecognition(message, accountIds)
      return this.createRecognition(message, accountIds)
    },

    async updateRecognition(message, accountIds) {
      try {
        this.isLoading = true
        await api.recognition.update(
          this.organizationId,
          this.recognition._id,
          {
            content: message,
            accounts: accountIds,
          }
        )
        this.showSuccess(
          this.$t('recognitions.recognition_updated_successfully')
        )
        this.$track('recognitions.Edit', this.$store, { status: 'success' })
        this.$emit('saved')
      } catch (err) {
        this.handleRequestError(err)
        this.$track('recognitions.Edit', this.$store, { status: 'fail' })
      } finally {
        this.isLoading = false
      }
    },

    async createRecognition(message, accountIds) {
      try {
        this.isLoading = true
        await api.recognition.create(this.organizationId, {
          content: message,
          accounts: accountIds,
        })
        this.$track('recognitions.Create', this.$store, { status: 'success' })
        this.showSuccess(
          this.$t('recognitions.recognition_send_successWithCount', {
            count: accountIds.length,
          })
        )
        this.$emit('saved')
      } catch (err) {
        this.$track('recognitions.Create', this.$store, { status: 'fail' })
        this.handleRequestError(err)
      } finally {
        this.isLoading = false
      }
    },

    handleDiscardChanges() {
      this.$track('recognitions.Create', this.$store, {
        process: 'cancelCreate',
      })
      this.showDialog = false

      this.$emit('close')
    },
  },
}
</script>
